import { useQuery } from '@tanstack/react-query'
import { get } from 'src/utils/http'
import useAuth from './useAuth'
import { Session } from './useSession'
import { DocumentMetadata } from './useDocs'

export type DocumentSession = Session & DocumentMetadata;

const useSessions = ({
  fromLang,
  toLang
}: {
  fromLang: string,
  toLang: string
}) => {
  const { isLoggedIn } = useAuth()

  const {
    data: sessions,
    isFetching: isLoading,
  } = useQuery<DocumentSession[]>(
    [
      'sessions',
      fromLang,
      toLang,
    ],
    () =>
      get(
        'users/sessions',
        { params: { fromLang, toLang } },
      ),
    { enabled: isLoggedIn },
  )

  return {
    sessions,
    isLoading
  }
}

export default useSessions
